import React, { Component } from 'react';

// Import css files
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { BackImage, CompanyProfile } from 'C4';

export default class ProfileViewNew extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    let { id } = this.props.match.params;
    const { pathname } = this.props.location;
    if (pathname === '/main/virtual-branch') {
      id = 441;
    }
    if (pathname === '/main/smart-depart') {
      id = 501;
    }
    return (
      <div className="profileViewNew">
        <BackImage />
        <div className="profileGradient" />
        <CompanyProfile profileId={id} />
      </div>
    );
  }
}
